module.exports = __webpack_public_path__ + "img/new-splash.33585260.png";